export default __webpack_public_path__ + "madfit-screen-third.d15f5cc9.png";